import React, { FunctionComponent } from 'react';
import { RecruitmentEntryButtonProps, RecruitmentEntryButtonState } from './types';

type Props = RecruitmentEntryButtonProps & {
  state: RecruitmentEntryButtonState;
  handleClickEntry: () => void;
  handlePreviewClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  connectedFlag,
  recruitmentId,
  companyId,
  isFirst,
  dataCategory,
  dataValue,
  messageBoxId,
  isShowMag,
  handleRegisterModalOpen,
  state,
  handleClickEntry,
  isPreview,
  handlePreviewClick,
  hideOnFirstView = false,
}) => {
  if (!state.isInitialized) return null;

  const firstClass = isFirst ? 'recruitment-entry-button-first' : '';

  if (isFirst && hideOnFirstView) {
    return <span className={firstClass} aria-hidden="true" />;
  }

  let button = null;
  if (connectedFlag) {
    button = (
      <a
        href={`/messages/${messageBoxId}`}
        className={`button button-join button-join--recruitment button-bm button-border__icon ${firstClass} gtm-button-view-count`}
        data-event-name='button on screen'
        data-event="click"
        data-category={dataCategory.recruitmentContent}
        data-value={dataValue.topLoggedInToMessage}
      >
        <span className="material-symbols-outlined cdn-icon to-message">sms</span>
        メッセージを確認
      </a>
    );
  } else if (state.isStopped) {
    button = (
      <a href="javascript:void(0);" className={`button button-join button-bm button-not-allowed ${firstClass}`}>
        募集終了しました
      </a>
    );
  } else if (state.isNotLoggedIn) {
    const value = isFirst
      ? (state.attentionPeople >= 5 ? dataValue.topNotLoginAttentionEntry : dataValue.topNotLoginEntry)
      : dataValue.notLoginEntry;
    button = (
      <a
        href="javascript:void(0);"
        onClick={handleRegisterModalOpen}
        className={`button button-join button-bm ${firstClass} gtm-entry-view-count`}
        data-event-name='entry on screen'
        data-event="click"
        data-category={dataCategory.recruitmentContent}
        data-value={value}
        data-type="recruitment"
        data-state={isShowMag ? 'with_mag' : 'no_mag'}
        data-ab-test="top_entry_button__shown"
      >
        まずはエントリー
      </a>
    );
  } else {
    const value = isFirst
      ? state.isScouted
        ? (state.attentionPeople >= 5 ? dataValue.topLoggedInScoutAttentionEntry : dataValue.topLoggedInScoutEntry)
        : (state.attentionPeople >= 5 ? dataValue.topLoggedInAttentionEntry : dataValue.topLoggedInEntry)
      : (state.isScouted ? dataValue.loggedInScoutEntry : dataValue.loggedInEntry);
    button = (
      <a
        href="javascript:void(0);"
        onClick={isPreview ? handlePreviewClick: handleClickEntry}
        className={`button button-join button-bm ${firstClass} gtm-entry-view-count`}
        data-event-name='entry on screen'
        data-event="click"
        data-category={dataCategory.recruitmentContent}
        data-value={value}
        data-state={isShowMag ? 'with_mag' : 'no_mag'}
        data-ab-test="top_entry_button__shown"
      >
        まずはエントリー
      </a>
    );
  }

  return (
    <>
      {button}
      {!state.isStopped && !connectedFlag && state.attentionPeople >= 5 && (
        <p
          className="attention gtm-recruitment-view-count"
          data-event-name='recruitments on screen'
          data-category={dataCategory.recruitmentContent}
          data-value={dataValue.recruitmentAttention}
          data-recruitmentid={recruitmentId}
          data-companyid={companyId}
        >
          {state.attentionPeople}人が注目しています
        </p>
      )}
    </>
  );
};
